import { useEffect, useState } from "react";

/**
 * Keeps a lazily mounted overlay mounted after its first open so closing it
 * can use its normal exit transition and it can be reopened without remounting.
 */
export const useHasOpened = (isOpen: boolean) => {
  const [hasOpened, setHasOpened] = useState(isOpen);

  useEffect(() => {
    if (isOpen) setHasOpened(true);
  }, [isOpen]);

  return hasOpened;
};

export default useHasOpened;
